import types from "../types/types";

const shifts = (payload) => ({
  type: types.SET_SHIFTS,
  payload,
});

export default shifts;
